/** @format */

import {
	DSProductRecommendationsModule,
	ProductRecommendationsComponent
} from '@product-recommendations/components';
import { HmfButtonComponent, HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconAlertErrorOutlined,
	homefieldIconSignCircledCheck
} from '@dsg-tech/homefield-angular-icons';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { AddOnModule } from '@shared/components';
import { AddToCartSuccessComponent } from './add-to-cart-success.component';
import { CommonModule } from '@angular/common';
import { PurchaseWarrantyComponent } from '@dsg-tech/non-merch-common-externals';

@NgModule({
	declarations: [AddToCartSuccessComponent],
	imports: [
		AddOnModule,
		CommonModule,
		DSProductRecommendationsModule,
		HmfButtonComponent,
		HmfTextLinkComponent,
		HomefieldIconLibraryModule,
		ProductRecommendationsComponent,
		PurchaseWarrantyComponent,
		PurchaseWarrantyComponent
	],
	exports: [AddToCartSuccessComponent],
	schemas: [NO_ERRORS_SCHEMA]
})
export class AddToCartSuccessModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconAlertErrorOutlined,
			homefieldIconSignCircledCheck,
			homefieldIconAlertErrorOutlined
		]);
	}
}
